module.exports = __webpack_public_path__ + "img/top16.02a2fbc6.png";